import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { googleAuthSession } from '../services/api';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const { setUserAndToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }

    const sessionId = match[1];

    const process = async () => {
      try {
        const data = await googleAuthSession(sessionId);
        // Store token and user
        localStorage.setItem('token', data.access_token);
        if (setUserAndToken) {
          setUserAndToken(data.access_token, data.user);
        }
        // Clean URL and redirect
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login');
      }
    };

    process();
  }, [navigate, setUserAndToken]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#D97757] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#596652]">Signing you in...</p>
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
